import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { HOLIDAY_SPEND_CHALLENGE_ENABLED_250807 } from "@faire/web-api--source/indigofair/settings/HOLIDAY_SPEND_CHALLENGE_ENABLED_250807";

export const useSettingHolidaySpendChallengeEnabled = (): boolean =>
  useSetting(HOLIDAY_SPEND_CHALLENGE_ENABLED_250807, false);
